export enum LoadingStatus {
  IDLE,
  LOADING,
  SUCCESS,
  ERROR,
}
